import { ObjectValues } from 'types/common';

export const LOCATION_FORM_NAMES = {
  Scf: 'scf',
  States: 'states',
  Zips: 'zips',
} as const;

export type LocationFormNames = ObjectValues<typeof LOCATION_FORM_NAMES>;
